import React, { useState } from 'react';
import { TextField, Button, AppBar, Toolbar, Tooltip, Container, Typography, Modal, FormControl, TableCell, TableContainer, TableHead, TableRow, Paper, Box } from '@mui/material';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddDepartment = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'
  const [departmentName, setDepartmentName] = useState('');
  const [departmentDetails, setDepartmentDetails] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  let navigate = useNavigate();
  const handleSave = async (e) => {
    e.preventDefault();

    if (!departmentName.trim()) {
      // alert("Please Enter Department name");
      setSnackbarMessage('Please Enter Department name');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Department`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          departmentName: departmentName,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setLoadingBarProgress(100);
        
        // Check the status field in the response
        if (responseData.status === 'Failed!' || responseData.status === 'failed') {
          setModalType('error');
          setModalMessage(responseData.msg || 'Operation failed');
        } else {
          setModalType('success');
          setModalMessage(responseData.msg || 'Department Added Successfully');
        }
        
        setModalOpen(true);
        if (responseData.status !== 'Failed!' && responseData.status !== 'failed') {
          setDepartmentName('');
        }
      } else {
        setLoadingBarProgress(0);
        const responseData = await response.json();
        setModalType('error');
        setModalMessage(responseData.msg || 'Unable to add Department');
        setModalOpen(true);
      }
    } catch (error) {
      console.error('API request error:', error);
      setLoadingBarProgress(0);
      setModalType('error');
      setModalMessage('An error occurred. Please try again later.');
      setModalOpen(true);
    }
  };

  const handleCancel = () => {
    setDepartmentName('');
  };

  const handleEdit = (index) => {
    console.log(`Edit Department details at index ${index}`);
    // Add logic to handle edit action
  };

  const handleDelete = (index) => {
    setDepartmentDetails((prevDetails) =>
      prevDetails.filter((_, i) => i !== index)
    );
  };

  return (
    <Container mt={4}>

      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Department
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <div>
          <TextField
            label="Department Name"
            variant="outlined"
            fullWidth
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!departmentName && "Enter Department Name"} arrow>
            <span><Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              sx={{ mr: 2 }}
              disabled={!departmentName}
            >
              SAVE
            </Button></span></Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ 
            backgroundColor: modalType === 'success' ? '#0B1F40' : '#d32f2f', 
            padding: '12px 16px' 
          }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'success' ? 'Success ✅' : 'Error ❌'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage}
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType === 'success') {
                    navigate(-1);
                  }
                }}
                variant="contained"
                color={modalType === 'success' ? 'primary' : 'error'}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      {/* Snackbar removed - using modal instead */}
    </Container>
  );
};

export default AddDepartment;
